import { Text, Tooltip } from '@dixa/lib-shared-habla';
import { InstrumentPanel } from 'lib-analytics-types';
import { memo } from 'react';

import { InstrumentPanelDescriptionEditor } from './components/editor/instrumentPanelDescriptionEditor';

export type InstrumentPanelDescriptionProps = {
  /** The instrument panel. */
  panel: InstrumentPanel;
  /**
   * If provided, the description becomes editable and this function is called
   * with the updated description when blurring the textarea.
   */
  onChange?: ({ description }: InstrumentPanelDescriptionFormValues) => void;
};

type InstrumentPanelDescriptionFormValues = {
  description?: string;
};

export const InstrumentPanelDescription = memo(
  function AnalyticsPanelDescriptionEditor({
    panel,
    onChange,
  }: InstrumentPanelDescriptionProps): JSX.Element | null {
    const isEditable = typeof onChange === 'function';

    if (isEditable) {
      return (
        <InstrumentPanelDescriptionEditor panel={panel} onChange={onChange} />
      );
    }

    // If not editable, render the description as text only if available.
    return panel.description ? (
      <Tooltip content={panel.description} side="top" wrap="div">
        <Text.Paragraph as="div" variant="4" subdued>
          {panel.description}
        </Text.Paragraph>
      </Tooltip>
    ) : null;
  },
);
